import React, { useState, useEffect, useContext } from 'react';

import { IGroups, IUsers } from  '@/interfaces/api/ContentAudience';
import { ResourcePermission } from  '@/interfaces/orgSettings';


import { getGroupsForUser } from '@/api/contentAudience';
import { ContentAudienceContext } from '../ContentAudienceContext';



const useViewPermissionsControl = ({user}: {user: IUsers}) => {
    const [currentPermissions, setCurrentPermissions ] = useState<ResourcePermission>();
    const [showTooltip, setShowTooltip] = useState<boolean>(false);
    const [groups, setGroups] = useState<IGroups[]>([])
    const [totalGroups, setTotalGroups] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { contentId, isOrgAdmin } = useContext(ContentAudienceContext)

    useEffect(() => {
        if(showTooltip) {
            setIsLoading(true);
            getGroupsForUser(contentId, user.id).then((data) => {
                setGroups(data.records.splice(0,5));
                setTotalGroups(data.total);
            }).finally(() => {
                setIsLoading(false);
            })
        }
    }, [showTooltip])
    

    useEffect(() => {
        if (user) {
            setCurrentPermissions(user?.permission || ResourcePermission.READ)
        }
    }, [user?.permission])


    function getContentPermissionLevel(permission?: ResourcePermission){
        return (permission || currentPermissions) === ResourcePermission.MANAGE ? 'Can Edit' : 'View Only'
    }

    function handleTooltipClick(){
        const showTip = !showTooltip
        setShowTooltip(showTip)
    }


    return {
        currentPermissions,
        showTooltip,
        setShowTooltip,
        groups,
        totalGroups,
        isLoading,
        getContentPermissionLevel,
        isOrgAdmin,
        handleTooltipClick,
    }
}

export default useViewPermissionsControl